import * as React from 'react'

import DrillDownFilter from '~/client/src/shared/components/DrillDownFilter'
import { ListHeader } from '~/client/src/shared/components/ListHeader'

import { toCompoundIds } from '../filterCompoundIds'
import { useResourcePickerContext } from '../ResourcePickerContext'

const PickerFilters: React.FC = () => {
  const {
    filterSelection,
    filterSelectionAsIds,
    filterCategories,
    setFilterSelection,
  } = useResourcePickerContext()

  const visibleCategoryIds = React.useMemo(
    () => new Set(filterCategories.map(category => category.id)),
    [filterCategories],
  )

  const visibleSelectionAsIds = React.useMemo(
    () =>
      filterSelectionAsIds.filter(id => {
        const colonIdx = id.indexOf(':')
        if (colonIdx === -1) return false
        return visibleCategoryIds.has(id.slice(0, colonIdx))
      }),
    [filterSelectionAsIds, visibleCategoryIds],
  )

  const hiddenSelectionAsIds = React.useMemo(() => {
    const hiddenSelections = new Map<string, Set<string>>()

    for (const [facetKey, values] of filterSelection) {
      if (visibleCategoryIds.has(facetKey) || values.size === 0) continue
      hiddenSelections.set(facetKey, new Set(values))
    }

    return toCompoundIds(hiddenSelections)
  }, [filterSelection, visibleCategoryIds])

  const handleApply = React.useCallback(
    (selectedIds: string[]) => {
      setFilterSelection([...selectedIds, ...hiddenSelectionAsIds])
    },
    [setFilterSelection, hiddenSelectionAsIds],
  )

  const activeCount = filterSelectionAsIds.length

  if (filterCategories.length === 0) {
    return null
  }

  return (
    <ListHeader.Filter badgeCount={activeCount}>
      <DrillDownFilter.Platform
        categories={filterCategories}
        initialSelection={visibleSelectionAsIds}
        onApply={handleApply}
      />
    </ListHeader.Filter>
  )
}

export default PickerFilters
